import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InputField = styled(TextField)`
  width: 100%;
  margin-bottom: 20px;
`;
